import { Injectable } from '@angular/core';

@Injectable()
export class HybridOnlyGuard {
  constructor() {}

  canActivate(): boolean {
    return !window.MINGA_APP_BROWSER;
  }
}
